import { useEffect, useState } from "react";
import { fetchClientName } from "../../lib/notas";

/** Nombre del cliente al lado del número, si el número ya es de un cliente del equipo (POST /notes-v2/client-names, en lote).
 * Sin acceso (403) o sin coincidencia: no muestra nada. Ambiguo (más de un cliente): «varios clientes», sin elegir uno.
 * Un enlace normal (no useNavigate) para no exigirle un <Router> a quien use este componente en una prueba aislada. */
export default function NombreCliente({ phone }) {
  const [item, setItem] = useState(null);
  useEffect(() => {
    if (!phone) { setItem(null); return; }
    let vivo = true;
    fetchClientName(phone).then((it) => { if (vivo) setItem(it); });
    return () => { vivo = false; };
  }, [phone]);

  if (!item) return null;
  if (item.ambiguous) return <span className="nt-cliente amb" data-testid="nt-cliente-ambiguo">varios clientes</span>;
  if (!item.nombre) return null;
  return (
    <a href={`/clientes/${item.client_id}`} className="nt-cliente" data-testid="nt-cliente-nombre" title="Ver ficha del cliente"
      onClick={(e) => e.stopPropagation()}>
      {item.nombre}
    </a>
  );
}
